import { attach, createEffect, forward, sample } from 'effector';

import { errorType$ } from 'model/error.model';
import { RootDomain } from 'model/root.model';
import { sessionConfig$ } from 'model/session.model';
import { EmitEventPayload, EventSubscriber } from 'model/domain';

export const subscribers$ = RootDomain.store<EventSubscriber[]>([]);
export const subscribe = RootDomain.event<EventSubscriber>();
export const unsubscribe = RootDomain.event<Function>();
export const emit = RootDomain.event<EmitEventPayload>();

export const completed = RootDomain.event();
export const canceled = RootDomain.event();
export const cancel = RootDomain.event();

subscribers$
	.on(subscribe, (subscribers, item) => {
		return [...subscribers, item];
	})
	.on(unsubscribe, (subscribers, callback) => {
		return subscribers
			.filter(item => item.callback !== callback);
	});

forward({
	from: emit,
	to: attach({
		source: subscribers$,
		effect: createEffect({
			handler: (payload: { params: EmitEventPayload, subscribers: EventSubscriber[] }) => {
				payload.subscribers
					.filter(item => item.event === payload.params.event)
					.forEach(item => {
						item.callback(payload.params.payload);
					});
			},
		}),
		mapParams(params: EmitEventPayload, subscribers) {
			return { params, subscribers };
		},
	}),
});
sample({
	source: { session: sessionConfig$ },
	clock: completed,
	fn: ({ session }) => ({ event: 'completed', payload: { sessionId: session.id } }),
	target: emit,
});
sample({
	source: { session: sessionConfig$, errorType: errorType$ },
	clock: cancel,
	fn: ({ session, errorType }) => {
		if (errorType !== null) {
			return {
				event: 'error',
				payload: {
					type: errorType,
				},
			};
		}

		return { event: 'canceled', payload: { sessionId: session.id } };
	},
	target: emit,
});
